import { Inject, Pipe, PipeTransform } from 'ng-metadata/core';
import { ContentDocument } from '../content-document.model';
import { ContentDocumentAdapterService } from './content-document-adapter.service';

/**
 * @ngdoc filter
 * @name mwContentDocumentAdapter
 * @module mw.components.contentDocuments
 *
 * @param {Object} document - Media type document to be converted to a ContentDocument model.
 * @returns {ContentDocument} The adapted ContentDocument model.
 *
 * @description
 * `mwContentDocumentAdapter` filter/pipe adapts a document of varying media type to a standard ContentDocument model instance.
 *
 */
@Pipe({ name: 'mwContentDocumentAdapter' })
export class ContentDocumentAdapterPipe implements PipeTransform {
    constructor(
        @Inject('mwContentDocumentAdapterService') private contentDocumentService: ContentDocumentAdapterService
    ) {}

    transform(document: Object): ContentDocument {
        return this.contentDocumentService.toContentDocument(document);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/content-document-adapter.pipe.ts